var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirectorioGac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.59 21.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #fff;\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 17.76,
    cy: 4.68,
    rx: 3.63,
    ry: 4.18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.38,
    y1: 17.13,
    x2: 22.38,
    y2: 21.26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.37,
    y1: 17.06,
    x2: 13.37,
    y2: 21.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.67,10.74h0c4.57,0,8.28,3.71,8.28,8.28v1.35c0,.49-.4.89-.89.89h-14.78c-.49,0-.89-.4-.89-.89v-1.35c0-4.57,3.71-8.28,8.28-8.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 28.01,
    cy: 5.33,
    rx: 3.13,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 32,
    y1: 16.09,
    x2: 32,
    y2: 19.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.38,11.51c1.05-.6,2.26-.95,3.56-.95h0c3.95,0,7.15,3.2,7.15,7.15v1.17c0,.42-.34.77-.77.77h-6.98"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 7.58,
    cy: 5.38,
    rx: 3.13,
    ry: 3.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.59,
    y1: 16.14,
    x2: 3.59,
    y2: 19.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.21,11.56c-1.05-.6-2.26-.95-3.56-.95h0c-3.95,0-7.15,3.2-7.15,7.15v1.17c0,.42.34.77.77.77h6.98"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectorioGac);
export default __webpack_public_path__ + "static/media/DirectorioGAC.fbf4f722753af4b3c50bce616ae6396e.svg";
export { ForwardRef as ReactComponent };